import ajax from "plugins/AjaxService"
import { BiAlerts, BiCropLots, BiIncidentPerCropLot } from "stores/bi/types"
import { DateRange } from "types/global"
import { dateToString } from "utils"



/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-56275
 */
async function indexYield(farmId: number, range: DateRange): Promise<BiCropLots[]> {
	const request = {
		queryParams: {
			presets: ["bi_crop_lots"],
			extraData: ["bi_layers", "bi_crop_cycles"],
		},
		filterParams: {
			presets: {
				biCropLots: {
					rejected: false,
					startDate: dateToString(range.start),
					endDate: dateToString(range.end),
				},
			},
			farmId
		}
	}
	const { data } = await ajax.post(`bi/table`, request) as { data: { biCropLots: BiCropLots[] } }
	return data.biCropLots
}

async function indexIncidents(farmId: number, range: DateRange): Promise<BiIncidentPerCropLot[]> {
	const request = {
		queryParams: {
			presets: ["bi_incident_per_crop_lot"]
		},
		filterParams: {
			presets: {
				biIncidentPerCropLot: {
					rejected: false,
					startDate: dateToString(range.start),
					endDate: dateToString(range.end),
				},
			},
			farmId
		}
	}
	const { data } = await ajax.post(`bi/table`, request) as { data: { biIncidentPerCropLot: BiIncidentPerCropLot[] } }
	return data.biIncidentPerCropLot
}

async function indexAlerts(farmId: number, range: DateRange): Promise<BiAlerts[]> {
	const request = {
		queryParams: {
			presets: ["bi_alarms"]
		},
		filterParams: {
			presets: {
				biAlarms: {
					startDate: dateToString(range.start),
					endDate: dateToString(range.end),
				},
			},
			farmId
		}
	}
	const { data } = await ajax.post(`bi/table`, request) as { data: { biAlarms: BiAlerts[] } }
	return data.biAlarms
}


const biApi = {
	indexYield,
	indexIncidents,
	indexAlerts,
}

export default biApi
